<template>
    <el-dialog :visible.sync="pwdModal" width="488px" top="26vh" :title="$t('common.waring')" append-to-body>
        <div class="sys-common-pwd-action">{{ $t('common.passwordaction') }}</div>
        <el-form :model="ruleForm" ref="pwdForm" label-width="10px">
            <el-form-item prop="passCode">
                <el-input :placeholder="$t('common.inputplaceholder')" v-model="ruleForm.passCode" size="medium"
                    show-password></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="pwdModal = false" class="sys-btn-default">{{ $t('common.cancel')
                }}</el-button>
            <el-button @click="actionSave" type="primary">{{ $t('common.confirm') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            pwdModal: false,
            ruleForm: {
                passCode: '',
            }

        }
    },
    methods: {
        open() {
            this.pwdModal = true;
            this.ruleForm.passCode = '';
        },
        close() {
            this.pwdModal = false;
        },
        actionSave() {
            if (this.ruleForm.passCode === '') {
                this.$message.error(vm.$t('common.inputplaceholder'));
                return false;
            }
            this.$emit('actionSave', this.ruleForm.passCode);
        }
    }
}
</script>